module.exports = __webpack_public_path__ + "static/cmmi-logo-48dd5e4fb4d40a23dac6150521811069.png";